<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState(['isRouterAlive']),
  },
}
</script>

<style lang="less">
@import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue